const plugins: Record<string, () => Promise<unknown>> = {
  coverage: () =>
    import(/* webpackChunkName: "coverage" */ './coverage/src').then(mdl => mdl.init()),
  guides: () => import(/* webpackChunkName: "guides" */ './guides/src').then(mdl => mdl.init()),
  support: () => import(/* webpackChunkName: "support" */ './support/src').then(mdl => mdl.init()),
  'agent-terminal/button': () =>
    import(/* webpackChunkName: "agent-terminal/button" */ './agent-terminal/src/button').then(
      mdl => mdl.init(),
    ),
  'agent-terminal/terminalPage': () =>
    import(
      /* webpackChunkName: "agent-terminal/terminal-page" */ './agent-terminal/src/terminalPage'
    ).then(mdl => mdl.init()),
  'agent-terminal/terminalPanel': () =>
    import(
      /* webpackChunkName: "agent-terminal/terminal-panel" */ './agent-terminal/src/terminalPanel'
    ).then(mdl => mdl.init()),
  'agent-terminal/terminal': () =>
    import(
      /* webpackChunkName: "agent-terminal/terminal" */ './agent-terminal/src/terminalContainer'
    ).then(mdl => mdl.init()),
  'agent-terminal/agentBlockedStatus': () =>
    import(
      /* webpackChunkName: "agent-terminal/agent-blocked-status" */ './agent-terminal/src/agentBlockedStatus'
    ).then(mdl => mdl.init()),
  'token-management': () =>
    import(/* webpackChunkName: "token-management" */ './token-management/src').then(mdl =>
      mdl.init(),
    ),
}
export default plugins
